import { DatePipe, NgClass } from '@angular/common';
import { Component, ElementRef, ViewChild } from '@angular/core';
import { ReactiveFormsModule, FormGroup, FormControl, Validators, FormsModule } from '@angular/forms';
import { MatIcon } from '@angular/material/icon';
import { MatPaginatorModule, MatPaginator } from '@angular/material/paginator';
import { MatTableModule, MatTableDataSource } from '@angular/material/table';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgToggleModule } from 'ng-toggle-button';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import Swal from 'sweetalert2';
import { BASE_IMAGE_URL, PAGELENGTH } from 'src/app/endpoints';
import { CardComponent } from 'src/app/shared/components/card/card.component';
import { CompanyService } from 'src/app/shared/service/company/company.service';
import { SampleService } from 'src/app/shared/service/sample/sample.service';
import { RouterLink } from '@angular/router';
import { MatInputModule } from '@angular/material/input';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatNativeDateModule, MatOption } from '@angular/material/core';
declare var bootstrap: any;

@Component({
  selector: 'app-company',
  imports: [
    CardComponent,
    MatTableModule,
    MatPaginatorModule,
    NgToggleModule,
    MatIcon,
    ReactiveFormsModule,
    DatePipe,
    NgSelectModule,
    RouterLink,
    MatInputModule,
    MatFormFieldModule,
    MatDatepickerModule,
    MatNativeDateModule,
    FormsModule,
    NgClass,
  ],
  templateUrl: './company.component.html',
  styleUrl: './company.component.scss'
})
export class CompanyComponent {
  // ------------------------------ COMPANY SECTION ------------------------------

  formType: string = 'Add';
  companyModal: any;
  companyStartpoint = 0;
  companyPageNo = 0;
  COMPANY_PAGELENGTH = 10;
  companySearch: any;
  totalLoaded: number;
  total: any;
  pageNo: any;
  companyRes: any;
  companyId: any;
  allCategoriesMini: any;
  companyDetail: any;
  pageSize: any

  companyForm = new FormGroup({
    _id: new FormControl(''),
    name: new FormControl('', [Validators.required]),
    company_image: new FormControl('', [Validators.required]),
    email: new FormControl('', [Validators.required, Validators.email]),
    password: new FormControl('', [Validators.required]),
    phone: new FormControl('', [
      Validators.required,
      Validators.pattern(/^\d{10}$/)
    ])
  });

  companyDisplayedColumns: string[] = [
    'position', 'name', 'logo', 'email', 'phone', 'createdAt', 'isBlocked', 'samples', 'viewRecipients', 'action'
  ];

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild('fileInput') fileInput: ElementRef;



  dataSource = new MatTableDataSource<any>([]);


  // ------------------------------ LIFECYCLE HOOKS ------------------------------

  constructor(
    private companyService: CompanyService,
    private sampleService: SampleService,
    private toastr: ToastrService,
    private spinner: NgxSpinnerService
  ) { }

  ngOnInit(): void {
    this.getAllCompanies(null);
  }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    const modalElement = document.getElementById('companyModal');
    if (modalElement) this.companyModal = new bootstrap.Modal(modalElement);

  }

  // ------------------------------ UTILS ------------------------------

  getImg(imgPath: any) {
    return BASE_IMAGE_URL + imgPath;
  }

  // ------------------------------ COMPANY METHODS ------------------------------

  filter(event: any) {
    this.companySearch = event.target.value?.trim();
    if (!this.companySearch) delete this.companySearch;
    this.getAllCompanies(null);
  }

  getAllCompanies(event: any) {
    this.spinner.show();
    if (!event) {
      this.companyPageNo = 0;
      this.companyStartpoint = 0;
      this.pageSize = this.pageSize || this.COMPANY_PAGELENGTH;
      this.dataSource.data = [];
      this.totalLoaded = 0;
    }

    if (event?.pageSize && event.pageSize !== this.pageSize) {
      this.pageSize = event.pageSize;
      this.companyPageNo = 0;
      this.companyStartpoint = 0;
      this.dataSource.data = [];
      this.totalLoaded = 0;
    }

    if (event?.pageIndex !== undefined) {
      this.companyPageNo = event.pageIndex;
      this.companyStartpoint = this.companyPageNo * (this.pageSize || this.COMPANY_PAGELENGTH);
    }
    let data: any = {
      startpoint: this.companyStartpoint,
      limit: this.pageSize || this.COMPANY_PAGELENGTH
    };
    if (this.companySearch) data.search = this.companySearch;

    this.companyService.allCompanies(data).subscribe({
      next: (result) => {
        this.spinner.hide();
        if (result.success) {
          this.total = result.total ?? 0;
          this.dataSource.data = result.data || [];
          this.totalLoaded = this.dataSource.data.length;
          setTimeout(() => {
            if (this.paginator) {
              this.paginator.pageIndex = this.companyPageNo;
              this.paginator.length = this.total;
              this.paginator.pageSize = this.pageSize ?? this.COMPANY_PAGELENGTH;
            }
          }, 0);
        }
      },
      error: (e: any) => {
        this.spinner.hide();
        let errorMsg = "An unexpected error occurred.";
        if (e.status === 0) {
          errorMsg = "Server not reachable. Try again later.";
        } else if (e.message) {
          errorMsg = e.message;
        }
        this.toastr.error(errorMsg, "Error");
      },
      complete: () => this.spinner.hide()
    });
  }



  openModel(type: any, companyId: any) {
    this.formType = type;
    this.companyId = companyId;
    if (companyId !== null) {
      this.spinner.show();
      this.companyService.singleCompany({ _id: companyId }).subscribe({
        next: (v: any) => {
          if (v.success) {
            this.companyForm.patchValue({
              name: v.data?.name,
              company_image: v.data?.image,
              email: v.data?.email,
              password: v.data?.password,
              phone: v.data?.phone,
            });
          } else {
            console.log(v.message);
          }
        },
        error: (e: any) => {
          this.spinner.hide();
          this.toastr.error(e.message, 'Error');
        },
        complete: () => this.spinner.hide()
      });
    }
    this.companyModal.show();
  }

  hideModel() {
    this.companyForm.reset();
    if (this.fileInput) this.fileInput.nativeElement.value = '';
    this.companyModal.hide();
  }

  submit() {
    this.spinner.show();
    let data = new FormData();
    data.append('name', this.companyForm.value.name ?? '');
    data.append('company_image', this.companyForm.value.company_image ?? '');
    data.append('email', this.companyForm.value.email ?? '');
    data.append('password', this.companyForm.value.password ?? '');
    data.append('phone', this.companyForm.value.phone ?? '');

    if (this.formType === 'Add') {
      this.companyService.addCompany(data).subscribe({
        next: (v: any) => {
          this.spinner.hide();
          if (v.success) {
            this.toastr.success(v.message, 'Success');
            this.hideModel();
            this.getAllCompanies(null);
          } else {
            this.toastr.error(v.message, 'Error');
          }
        },
        error: (e: any) => {
          this.spinner.hide();
          const errorMsg = e.status === 0
            ? "Server not reachable. Try again later."
            : e.message || 'An unexpected error occurred.';
          this.toastr.error(errorMsg, 'Error');
        },
        complete: () => {
          this.spinner.hide();
          this.hideModel();
        }
      });
    } else {
      data.append('_id', this.companyId ?? '');
      this.companyService.updateCompany(data).subscribe({
        next: (v: any) => {
          this.spinner.hide();
          if (v.success) {
            this.toastr.success(v.message, 'Success');
            this.hideModel();
            this.getAllCompanies(null);
          } else {
            this.toastr.error(v.message, 'Error');
          }
        },
        error: (e: any) => {
          this.spinner.hide();
          const errorMsg = e.status === 0
            ? "Server not reachable. Try again later."
            : e.message || 'An unexpected error occurred.';
          this.toastr.error(errorMsg, 'Error');
        },
        complete: () => {
          this.spinner.hide();
          this.hideModel();
        }
      });
    }
  }

  onToggleClick(element: any) {
    const currentStatus = element.isBlocked;
    const newStatus = !currentStatus;
    const action = newStatus ? 'Block' : 'Unblock';
    const swalWithBootstrapButtons = Swal.mixin({
      customClass: {
        confirmButton: 'btn btn-success',
        cancelButton: 'btn btn-danger',
      },
      buttonsStyling: false,
    });
    swalWithBootstrapButtons
      .fire({
        title: `${action} this Company?`,
        text: `This will ${action.toLowerCase()} the Company.`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: `${action}`,
        cancelButtonText: 'Cancel',
        reverseButtons: true,
      })
      .then((result) => {
        if (result.isConfirmed) {
          this.companyService
            .enableDisableCompany({ _id: element._id, isBlocked: newStatus })
            .subscribe({
              next: (v: any) => {
                if (v.success) {
                  element.isBlocked = newStatus;
                  this.toastr.success(`Company ${action.toLowerCase()}ed successfully.`);
                } else {
                  this.toastr.error(v.message, 'Error');
                }
              },
              error: (e: any) => {
                this.toastr.error(e.message, 'Error');
              },
            });
        }
      });
    return false;
  }




 uploadImage(event: any) {
  const file = event.target.files[0];
  if (!file) return;

  // File type validation
  if (file.type !== 'image/jpeg' && file.type !== 'image/jpg' && file.type !== 'image/png') {
    this.toastr.info("Only JPG, JPEG and PNG images are allowed.");
    event.target.value = "";
    return;
  }

  // Check aspect ratio
  const img = new Image();
  img.src = URL.createObjectURL(file);
  img.onload = () => {
    const aspectRatio = img.width / img.height;
    if (Math.abs(aspectRatio - 1) < 0.01) {   // 16:9 ratio (allowing small tolerance)
      this.companyForm.patchValue({ company_image: file });
    } else {
      this.toastr.error("Image aspect ratio must be 1:1. (251 PX X 251 PX)");
      event.target.value = "";
    }
  };
}



}
